import { Modal } from '@mantine/core';
import { useDataSourcesModal } from '@mygpt/app';
import CreateV2 from '@/components/Create_V2';
import { useCreateStore } from '@/store/create';

export default () => {
  const { onClose, opened } = useDataSourcesModal();
  const { creating } = useCreateStore();

  return (
    <Modal opened={opened} onClose={onClose} size={'auto'} centered closeOnClickOutside={!creating}>
      <div className="flex flex-col" style={{ position: 'relative', width: '100vw', maxWidth: 1000, minHeight: 700 }}>
        <CreateV2 />
      </div>
    </Modal>
  );
};
